import {
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaTwitter,
} from "react-icons/fa";
import LanguageIcon from "@mui/icons-material/Language";
import {
  EJEMPLO_SITIO_WEB,
  REDES,
  ayudaCampo,
  normalizarRed,
  normalizarSitioWeb,
} from "../../utils/redesSociales";

// Cada red solo acepta un link de esa red o el usuario con @; el texto de
// ayuda muestra el error, o a qué link va a quedar convertido el @usuario.
const CAMPOS_REDES = [
  { red: "instagram", label: "Cuenta de Instagram", Icono: FaInstagram },
  { red: "tiktok", label: "Cuenta de TikTok", Icono: FaTiktok },
  { red: "twitter", label: "Cuenta de X (Twitter)", Icono: FaTwitter },
  { red: "facebook", label: "Cuenta de Facebook", Icono: FaFacebook },
];

export default function Step4P({ changeForm, mainData }) {
  const sitioWeb = normalizarSitioWeb(mainData?.pagina_web);

  return (
    <Stack alignItems="center">
      <Stack
        spacing={2.3}
        width={{ xs: "100%", sm: "90%", md: "70%", lg: "50%" }}
      >
        <Stack spacing={0.5}>
          <Typography variant="p">
            Confirma al menos una red social o tu página web para que los
            artistas puedan conocer tu medio:
          </Typography>
          <Typography variant="caption" color="grayText">
            Con agregar uno de los siguientes links es suficiente. En cada red
            puedes pegar el link de tu perfil o escribir tu usuario con @.
            Podrás completar el resto más adelante desde tu perfil.
          </Typography>
        </Stack>
        {CAMPOS_REDES.map(({ red, label, Icono }) => {
          const resultado = normalizarRed(red, mainData?.[red]);
          return (
            <TextField
              key={red}
              label={label}
              value={mainData?.[red] || ""}
              onChange={changeForm(red)}
              error={!resultado.ok}
              helperText={ayudaCampo(resultado, REDES[red].ejemplo)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icono style={{ color: "#F27224" }} />
                  </InputAdornment>
                ),
              }}
            />
          );
        })}
        <TextField
          label="Página web"
          value={mainData?.pagina_web || ""}
          onChange={changeForm("pagina_web")}
          error={!sitioWeb.ok}
          helperText={ayudaCampo(sitioWeb, EJEMPLO_SITIO_WEB)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LanguageIcon sx={{ color: "#F27224" }} />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Stack>
  );
}
